import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "@jti/fe-common/constants";
const getRequiredCodeLength = ({ is12DeviceCodeLength, is15DeviceCodeLength, is16DeviceCodeLength, }) => {
    const requiredCodeLength = [];
    if (is12DeviceCodeLength) {
        requiredCodeLength.push(12);
    }
    if (is15DeviceCodeLength) {
        requiredCodeLength.push(15);
    }
    if (is16DeviceCodeLength) {
        requiredCodeLength.push(16);
    }
    if (requiredCodeLength.length === 0) {
        requiredCodeLength.push(16);
    }
    return requiredCodeLength;
};
const getRegisterDeviceAccordionImagesContent = ({ accordionImageOne, accordionImageOneAlt, accordionImageOneDescription, accordionImageTwo, accordionImageTwoAlt, accordionImageTwoDescription, }) => [
    {
        imageUrl: accordionImageOne || "",
        imageAlt: accordionImageOneAlt || "",
        description: accordionImageOneDescription || "",
    },
    {
        imageUrl: accordionImageTwo || "",
        imageAlt: accordionImageTwoAlt || "",
        description: accordionImageTwoDescription || "",
    },
].filter((item) => item.imageUrl && item.imageAlt && item.description);
export const deviceConfigurationToRegisterDialogPropsAdapter = (config) => {
    const { theme, registerDeviceImgDesktop, registerDeviceImgMobile, registerDeviceImgAlt, registerDeviceDialogTitle, registerDeviceDialogDescription, registerDeviceAccordionTitle, registerDeviceAccordionButtonUrl, registerDeviceAccordionButtonText, cancelDeviceRegistrationButtonText, confirmDeviceRegistrationButtonText, is12DeviceCodeLength, is15DeviceCodeLength, is16DeviceCodeLength, accordionImageOne, accordionImageOneAlt, accordionImageOneDescription, accordionImageTwo, accordionImageTwoAlt, accordionImageTwoDescription, } = config || {};
    return {
        imageAlt: registerDeviceImgAlt ?? "",
        title: registerDeviceDialogTitle || "",
        theme,
        imgMobile: registerDeviceImgMobile || "",
        imgDesktop: registerDeviceImgDesktop || "",
        description: registerDeviceDialogDescription || "",
        cancelButtonText: cancelDeviceRegistrationButtonText || "",
        confirmButtonText: confirmDeviceRegistrationButtonText || "",
        registerDeviceAccordionTitle: registerDeviceAccordionTitle || "",
        registerDeviceAccordionButtonUrl: registerDeviceAccordionButtonUrl || "",
        registerDeviceAccordionButtonText: registerDeviceAccordionButtonText || "",
        requiredCodeLength: getRequiredCodeLength({
            is12DeviceCodeLength,
            is15DeviceCodeLength,
            is16DeviceCodeLength,
        }) || DEFAULT_ALLOWED_DEVICE_CODE_LENGTH,
        registerDeviceAccordionImagesContent: getRegisterDeviceAccordionImagesContent({
            accordionImageOne,
            accordionImageOneAlt,
            accordionImageOneDescription,
            accordionImageTwo,
            accordionImageTwoAlt,
            accordionImageTwoDescription,
        }),
    };
};
//# sourceMappingURL=utils.js.map